import React from 'react';
import PropTypes from 'prop-types';
import { Trash2, FileText } from 'lucide-react';
import { ref, remove } from 'firebase/database';
import { database } from '../../../config/firebase';
import { getSubjectName } from '../../../utils/quizUtils';

const QuizContentList = ({
  assignedContentsDetails,
  activeSubject,
  isTeacher,
  studentId,
  onOpenContent,
  onViewResults
}) => {
  if (assignedContentsDetails.length === 0) {
    return (
      <p className="text-gray-600">現在、割り当てられたコンテンツはありません。</p>
    );
  }

  return (
    <div className="space-y-4">
      {assignedContentsDetails
        .filter(content => activeSubject === 'all' || content.subject === activeSubject)
        .map((content) => (
          <div key={content.id} className="p-4 bg-pink-50 rounded shadow">
            <div className="flex justify-between items-start">
              {/* コンテンツ表示部分 */}
              <div className="flex-1 cursor-pointer" onClick={() => onOpenContent(content.id)}>
                <h3 className="text-lg font-semibold text-purple-700 hover:text-purple-600">
                  {content.title}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-600">教科: {getSubjectName(content.subject)}</p>
                  <p className="text-sm text-gray-600">出題順序: {content.randomizeQuizzes ? 'ランダム' : '固定'}</p>
                  {content.timeLimitPerQuestion > 0 && !content.freeNavigation && (
                    <p className="text-sm text-gray-600">1問あたりの制限時間: {content.timeLimitPerQuestion}秒</p>
                  )}
                  {content.freeNavigation && content.timeLimitPerContent > 0 && (
                    <p className="text-sm text-gray-600">コンテンツ全体の制限時間: {content.timeLimitPerContent}秒</p>
                  )}
                  <p className="text-sm text-gray-600">問題移動: {content.freeNavigation ? '自由' : '一方向'}</p>
                  <p className="text-sm text-gray-600">
                    解答表示モード: {content.answerRevealMode === 'immediate' ? '即時表示' : '最後まとめ表示'}
                  </p>
                  <p className="text-sm text-gray-600">
                    回答方式: {(content.quickAnswerMode || 'standard') === 'quick' ? 'クイック回答' : '標準回答'}
                    {(content.quickAnswerMode || 'standard') === 'quick' && ' (四択・正誤問題)'}
                  </p>
                </div>
              </div>

              {/* ボタン部分 - 独立したdivで分離 */}
              <div className="flex items-start gap-2 ml-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onViewResults(content.id, content.title);
                  }}
                  className="text-purple-500 hover:text-purple-700 p-2 rounded"
                >
                  <FileText size={20} />
                </button>
                {isTeacher && (
                  <button
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (window.confirm('このコンテンツの割り当てを解除しますか？')) {
                        try {
                          await remove(ref(database, `studentAssignedContents/${studentId}/${content.id}`));
                          await remove(ref(database, `results/${studentId}/${content.id}`));
                          alert('コンテンツの割り当てが解除されました。');
                        } catch (error) {
                          console.error('解除失敗:', error);
                          alert('解除に失敗しました。');
                        }
                      }
                    }}
                    className="text-pink-500 hover:text-pink-700 p-2 rounded"
                    aria-label="割り当て解除"
                  >
                    <Trash2 size={20} />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

QuizContentList.propTypes = {
  assignedContentsDetails: PropTypes.array.isRequired,
  activeSubject: PropTypes.string.isRequired,
  isTeacher: PropTypes.bool.isRequired,
  studentId: PropTypes.string.isRequired,
  onOpenContent: PropTypes.func.isRequired,
  onViewResults: PropTypes.func.isRequired
};

export default React.memo(QuizContentList); 